import React, { createContext, useContext, useState } from 'react';

const AccessibilityContext = createContext();

export const AccessibilityProvider = ({ children }) => {
    const [fontSize, setFontSize] = useState(15);
    const [fontSelected, setFontSelected] = useState({
        small: false,
        medium: true,
        large: false
    });

    const increaseFontSize = () => {
        setFontSelected({
            small: false,
            medium: false,
            large: true
        });
        if (fontSize < 20) {
            setFontSize((prevState) =>
                prevState + 1
            );
        }
    };
    const decreaseFontSize = () => {
        setFontSelected({
            small: true,
            medium: false,
            large: false
        });
        if (fontSize > 10) {
            setFontSize((prevState) =>
                prevState - 1
            );
        }

    };
    const resetFontSize = () => {
        setFontSelected({
            small: false,
            medium: true,
            large: false
        });
        setFontSize(15);
    };

    const value = {
        fontSize,
        fontSelected,
        increaseFontSize,
        decreaseFontSize,
        resetFontSize,
    };

    return (
        <AccessibilityContext.Provider value={value}>
            {children}
        </AccessibilityContext.Provider>
    );
};

export const useAccessibility = () => {
    return useContext(AccessibilityContext);
};